import { FilterCriteria as IFilterCriteria } from 'interfaces';
import { EntityParameter, MilitaryClass } from 'types/entities';

import {
  FilterCriteria,
  FilterCriteriaType,
  FilterCriteriaValue,
} from './types';

export const getFilterCriteriaValueLabel = (
  type: FilterCriteriaType,
  value: unknown
): FilterCriteriaValue<string | number | unknown> => {
  if (type === 'text') {
    return {
      label: value as string,
      value: value as string,
    };
  }

  if (type === 'number') {
    return {
      label: String(value),
      value: value as number,
    };
  }

  if (type === 'date') {
    return {
      label: 'Дата',
      value: value,
    };
  }

  return { label: 'Неизвестное значение', value: value };
};

export const getFilterCriteria = (
  parameter: EntityParameter
): FilterCriteria => ({
  id: parameter.id,
  name: parameter.title,
  type: parameter.parameterType,
  label: parameter.title,
  values:
    parameter.settings.allowedValues?.map((value) =>
      getFilterCriteriaValueLabel(parameter.parameterType, value)
    ) ?? [],
});

export const addMilitaryHierarchyChildrenToFilterCriteria = (
  filterCriteria: IFilterCriteria,
  militaryClasses: MilitaryClass[]
) => {
  const nestedFilterValues: string[] = [];

  const addChildrenIfMatches = (mc: MilitaryClass, parentMatched: boolean) => {
    if (parentMatched || filterCriteria.values.find((v) => v === mc.Name)) {
      parentMatched = true;
      nestedFilterValues.push(mc.Name);
    }
    mc.Children?.forEach((c) => addChildrenIfMatches(c, parentMatched));
  };

  militaryClasses.forEach((mc) => addChildrenIfMatches(mc, false));

  return { ...filterCriteria, values: Array.from(new Set(nestedFilterValues)) };
};
